import { components } from '@api/club/generated';
import { TimeSyncService } from '@services/TimeSyncService';

import { useTimeHasCome } from '@libs/hooks/useTimeHasCome';

import {
  DEFAULT_MAX_TOURNAMENT_PARTICIPANTS,
  TOURNAMENT_MINIMUM_TIME_BEFORE_START,
} from '../constants';

export type ITournamentForStates = {
  status: components['schemas']['TournamentStatus'];
  startTimestampMs?: number | null;
  registrationTillTimestampMs?: number | null;
  participantsCount?: number | null;
  participantsCountMax?: number | null;
};

export function useTournamentStates(tournament?: ITournamentForStates | null) {
  const status = tournament?.status;
  const timeMs = tournament?.startTimestampMs;
  const participantsCount = tournament?.participantsCount || 0;
  const participantsCountMax =
    tournament?.participantsCountMax || DEFAULT_MAX_TOURNAMENT_PARTICIPANTS;

  const hasTime = Boolean(timeMs);
  const notStarted = status === 'NotStarted';

  const isRegistrationOpen = !useTimeHasCome(
    TimeSyncService.instance.toClientTimestamp(tournament?.registrationTillTimestampMs),
  );

  // За X минут до начала турнир становится нередактируемым
  const lockTimestamp = timeMs
    ? TimeSyncService.instance.toClientTimestamp(timeMs) - TOURNAMENT_MINIMUM_TIME_BEFORE_START
    : null;

  const areSettingsLocked = useTimeHasCome(lockTimestamp);

  const isPublishable = hasTime && status === 'Draft' && !areSettingsLocked;
  const isEditable = status === 'Draft' || (notStarted && !areSettingsLocked);
  const isModeration = status === 'InProgress' || status === 'Finished' || status === 'Paused';

  const isLive = status === 'InProgress' || status === 'Paused';
  const isFinished = status === 'Finished' || status === 'Deleted';

  const hasRoom = participantsCount < (participantsCountMax ?? DEFAULT_MAX_TOURNAMENT_PARTICIPANTS);

  const isNotTooLate = notStarted && !areSettingsLocked && isRegistrationOpen;

  return {
    isModeration,
    isEditable,
    isPublishable,
    isRegistrationOpen,
    isLive,
    isFinished,
    isJoinable: hasRoom && isNotTooLate,
    isLeavable: isNotTooLate,
  };
}
